/* =====================================================================
   NayHogar · Orden y calma (opción B) · tema.js
   Experiencias del tema, sin librerías: héroe con parallax, paneles por espacio, antes y después, compra el
   ambiente (tarjeta / hoja inferior), manifiesto con nivel, "una cosa a la vez", vitrina con pestañas y el
   planeador de orden. La base (carrito, producto, buscador) vive en core.js y se usa con window.NT.
   ===================================================================== */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const NT = window.NT || {};
  const money = c => (NT.formatMoney ? NT.formatMoney(c) : '$' + Math.round((+c || 0) / 100).toLocaleString('es-CO'));
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
  const leer = el => { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } };
  const norm = s => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  // comodidades guardadas en el navegador (nunca datos personales); si no hay almacenamiento, todo sigue funcionando
  const guardado = {
    get(k, d) { try { const v = window.localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { window.localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* sin almacenamiento */ } }
  };
  const ICON = {
    arrow: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    close: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>',
    check: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
    cash: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2.5" y="6" width="19" height="12" rx="2.5"/><circle cx="12" cy="12" r="2.6"/><path d="M6 9.5v5M18 9.5v5"/></svg>'
  };
  // si falla la red (fetch lanza TypeError) se muestra un mensaje en español; si Shopify responde, su propio mensaje
  const errorTexto = err => (!err || err instanceof TypeError || !err.message) ? 'No se pudo agregar. Revisa tu conexión e intenta de nuevo.' : err.message;
  let uidN = 0;
  const uid = p => p + (++uidN);
  const alScroll = fn => { let tic = false; const run = () => { tic = false; fn(); }; window.addEventListener('scroll', () => { if (!tic) { tic = true; requestAnimationFrame(run); } }, { passive: true }); window.addEventListener('resize', () => requestAnimationFrame(fn)); fn(); };
  const unaVez = el => { if (!el || el.dataset.nhOn) return false; el.dataset.nhOn = '1'; return true; };

  /* ---------- héroe: la foto se ordena sola (CSS) y, al bajar, se abre como vista explotada + parallax suave ---------- */
  function heroe(root) {
    $$('[data-nhero]', root).forEach(sec => {
      if (!unaVez(sec)) return;
      const tiles = $('[data-nhero-tiles]', sec);
      const piezas = $$('.nhero__tile', sec);
      if (!tiles || reduce) return;
      const dirs = [[-1, -1], [0, -1], [1, -1], [-1, 1], [0, 1], [1, 1]];
      alScroll(() => {
        const b = sec.getBoundingClientRect();
        if (b.bottom < 0 || b.top > window.innerHeight) return;
        const s = Math.max(0, -b.top);
        tiles.style.translate = '0 ' + (s * 0.08).toFixed(1) + 'px';
        if (piezas.length > 1) {
          const p = Math.min(1, s / Math.max(1, b.height * 0.75));
          piezas.forEach((t, i) => { const d = dirs[i] || [0, 0]; t.style.translate = (d[0] * p * 18).toFixed(1) + 'px ' + (d[1] * p * 14).toFixed(1) + 'px'; });
        }
      });
    });
  }

  /* ---------- por espacio: el panel que señalas se abre ---------- */
  function espacios(root) {
    $$('[data-nesp]', root).forEach(row => {
      if (!unaVez(row)) return;
      const ps = $$('[data-nesp-p]', row);
      const abrir = p => ps.forEach(x => x.classList.toggle('is-on', x === p));
      ps.forEach(p => {
        p.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') abrir(p); });
        p.addEventListener('focus', () => abrir(p));
      });
    });
  }

  /* ---------- antes y después ---------- */
  function antesDespues(root) {
    $$('[data-nba]', root).forEach(box => {
      if (!unaVez(box)) return;
      const range = $('[data-nba-range]', box);
      const notas = $$('[data-nba-note]', box);
      let tocado = false, anim = 0;
      const tag = $('.nba__tag', box);
      const pintar = v => {
        const pos = Math.max(0, Math.min(100, v));
        box.style.setProperty('--pos', pos.toFixed(2) + '%');
        if (tag) {
          const w = box.clientWidth, half = tag.offsetWidth / 2 + 10, x = w * pos / 100;
          const shift = Math.max(0, half - x) - Math.max(0, x + half - w);
          tag.style.setProperty('--shift', shift.toFixed(1) + 'px');
        }
        box.dataset.side = pos > 57 ? 'a' : (pos < 43 ? 'd' : '');
        notas.forEach(n => n.classList.toggle('is-off', +n.dataset.nbaNote < pos + 3));
        if (range) {
          const r = Math.round(pos);
          range.value = r;
          range.setAttribute('aria-valuetext', (range.dataset.a || 'Antes') + ' ' + r + ' %, ' + (range.dataset.d || 'Después') + ' ' + (100 - r) + ' %');
        }
      };
      const desdeX = x => { const b = box.getBoundingClientRect(); return (x - b.left) / b.width * 100; };
      const parar = () => { tocado = true; cancelAnimationFrame(anim); };
      let drag = false, decidido = false, x0 = 0, y0 = 0, tipo = '';
      box.addEventListener('pointerdown', e => {
        if (e.button) return;
        parar();
        drag = true; tipo = e.pointerType; decidido = tipo === 'mouse'; x0 = e.clientX; y0 = e.clientY;
        if (decidido) { pintar(desdeX(e.clientX)); box.classList.add('is-drag'); try { box.setPointerCapture(e.pointerId); } catch (er) {} }
      });
      box.addEventListener('pointermove', e => {
        if (!drag) return;
        if (!decidido) {
          const dx = Math.abs(e.clientX - x0), dy = Math.abs(e.clientY - y0);
          if (dx < 6 && dy < 6) return;
          if (dy > dx) { drag = false; return; } // gesto vertical: que la página baje
          decidido = true; box.classList.add('is-drag');
          try { box.setPointerCapture(e.pointerId); } catch (er) {}
        }
        pintar(desdeX(e.clientX));
      });
      const fin = e => {
        if (drag && !decidido && tipo !== 'mouse' && e && e.type === 'pointerup') pintar(desdeX(e.clientX)); // toque corto: salta ahí
        drag = false; box.classList.remove('is-drag');
      };
      box.addEventListener('pointerup', fin);
      box.addEventListener('pointercancel', fin);
      box.addEventListener('lostpointercapture', () => { drag = false; box.classList.remove('is-drag'); });
      if (range) range.addEventListener('input', () => { parar(); pintar(+range.value); });
      pintar(50);
      // pista: al aparecer, la línea se mece una vez para mostrar que se puede mover
      if (!reduce && 'IntersectionObserver' in window) {
        const ob = new IntersectionObserver(es => es.forEach(en => {
          if (!en.isIntersecting) return;
          ob.disconnect();
          if (tocado) return;
          const marcas = [[0, 50], [950, 71], [2000, 31], [2900, 50]];
          let t0 = 0;
          const paso = t => {
            if (tocado) return;
            if (!t0) t0 = t;
            const dt = t - t0;
            let i = 0;
            while (i < marcas.length - 1 && dt > marcas[i + 1][0]) i++;
            if (i >= marcas.length - 1) { pintar(50); return; }
            const a = marcas[i], b = marcas[i + 1], k = (dt - a[0]) / (b[0] - a[0]);
            const ease = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
            pintar(a[1] + (b[1] - a[1]) * ease);
            anim = requestAnimationFrame(paso);
          };
          setTimeout(() => { if (!tocado) anim = requestAnimationFrame(paso); }, 450);
        }), { threshold: .55 });
        ob.observe(box);
      }
    });
  }

  /* ---------- compra el ambiente: puntos + tarjeta (escritorio) / hoja inferior (celular) ---------- */
  function ambiente(root) {
    $$('[data-namb]', root).forEach(sec => {
      if (!unaVez(sec)) return;
      const P = leer($('[data-namb-json]', sec)) || [];
      const TX = leer($('[data-namb-txt]', sec)) || {};
      const dots = $$('[data-namb-dot]', sec), gos = $$('[data-namb-go]', sec);
      const card = $('[data-namb-card]', sec), body = $('[data-namb-body]', sec), scrim = $('.namb__scrim', sec);
      const scroller = $('[data-namb-scroll]', sec);
      if (!P.length || !card || !body) return;
      const mq = window.matchMedia('(max-width: 900px)');
      let cur = 0, foco = null;

      const variante = p => {
        if (p.s || !p.vs) return null;
        const sel = $$('select[data-opt]', body).map(s => s.value);
        if (!sel.length) return p.vs.find(v => v.id === p.v) || p.vs[0];
        return p.vs.find(v => v.o.every((o, i) => sel[i] == null || o === sel[i])) || null;
      };
      const precio = (p, v) => {
        const pr = v ? v.p : p.p, c = v ? v.c : p.c;
        return (p.pv && !v ? '<small>' + esc(TX.from || 'Desde') + '</small>' : '') + '<span>' + money(pr) + '</span>' + (c > pr ? '<s>' + money(c) + '</s>' : '');
      };
      const opciones = p => {
        if (p.s || !p.o || !p.vs || !p.vs.length) return '';
        const v0 = p.vs.find(v => v.id === p.v) || p.vs.find(v => v.a) || p.vs[0];
        return '<div class="ncard__opts">' + p.o.map((nombre, i) => {
          const vals = [];
          p.vs.forEach(v => { if (vals.indexOf(v.o[i]) < 0) vals.push(v.o[i]); });
          return '<label class="ncard__sel"><span>' + esc(nombre) + '</span><select data-opt="' + i + '">' +
            vals.map(val => '<option value="' + esc(val) + '"' + (v0 && v0.o[i] === val ? ' selected' : '') + '>' + esc(val) + '</option>').join('') +
            '</select></label>';
        }).join('') + '</div>';
      };
      const boton = (p, v) => {
        const b = $('[data-add]', body);
        if (!b) return;
        const ok = p.s ? p.a : !!(v && v.a);
        b.disabled = !ok;
        b.firstElementChild.textContent = ok ? (TX.add || 'Agregar al carrito') : (TX.out || 'Agotado');
      };

      function pintar(i, abrir) {
        cur = (i + P.length) % P.length;
        const p = P[cur];
        dots.forEach((d, k) => { d.classList.toggle('is-on', k === cur); d.setAttribute('aria-pressed', k === cur ? 'true' : 'false'); });
        gos.forEach((g, k) => g.classList.toggle('is-on', k === cur));
        body.innerHTML =
          '<div class="ncard">' +
            '<div class="ncard__top"><p class="ncard__k"><b>' + esc(p.n) + '</b>' + esc(p.k) + '</p><div class="ncard__nav">' +
              (P.length > 1 ? '<button type="button" class="ncard__prev" data-prev aria-label="Anterior">' + ICON.arrow + '</button><button type="button" data-next aria-label="Siguiente">' + ICON.arrow + '</button>' : '') +
              '<button type="button" class="ncard__x" data-namb-x aria-label="Cerrar">' + ICON.close + '</button></div></div>' +
            '<div class="ncard__main">' +
              '<a class="ncard__img" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="520" height="520">' : '') + '</a>' +
              '<p class="ncard__type">' + esc(p.ty) + '</p>' +
              '<h3 class="ncard__t"><a href="' + esc(p.u) + '">' + esc(p.t) + '</a></h3>' +
              '<p class="ncard__p" data-precio></p>' +
            '</div>' +
            opciones(p) +
            '<div class="ncard__btns"><button type="button" class="cta cta--sm" data-add><span></span></button><a class="ghost" href="' + esc(p.u) + '">' + esc(TX.see || 'Ver detalles') + '</a></div>' +
            '<p class="ncard__cod">' + ICON.cash + esc(TX.cod || '') + (TX.ship ? ' · ' + esc(TX.ship) : '') + '</p>' +
          '</div>';
        const v = variante(p);
        $('[data-precio]', body).innerHTML = precio(p, p.s ? null : v);
        boton(p, v);
        if (abrir && mq.matches) abrirHoja();
      }

      function abrirHoja() {
        if (!card.classList.contains('open')) foco = document.activeElement;
        card.classList.add('open');
        if (scrim) scrim.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        setTimeout(() => { const x = $('[data-namb-x]', card); if (x) x.focus({ preventScroll: true }); }, 80);
      }
      function cerrarHoja(sinFoco) {
        if (!card.classList.contains('open')) return;
        card.classList.remove('open');
        if (scrim) scrim.hidden = true;
        document.documentElement.style.overflow = '';
        if (!sinFoco && foco && foco.focus) foco.focus({ preventScroll: true });
      }
      function centrar(i) {
        if (!scroller || !mq.matches || !dots[i]) return;
        const pic = dots[i].parentElement;
        const x = parseFloat(dots[i].style.left) / 100 * pic.clientWidth;
        scroller.scrollTo({ left: Math.max(0, x - scroller.clientWidth / 2), behavior: reduce ? 'auto' : 'smooth' });
      }

      dots.forEach((d, k) => d.addEventListener('click', () => pintar(k, true)));
      gos.forEach((g, k) => g.addEventListener('click', e => { e.preventDefault(); centrar(k); pintar(k, true); }));
      if (scrim) scrim.addEventListener('click', () => cerrarHoja());
      body.addEventListener('change', e => {
        if (!e.target.matches('select[data-opt]')) return;
        const p = P[cur], v = variante(p);
        $('[data-precio]', body).innerHTML = precio(p, v || null);
        boton(p, v);
      });
      body.addEventListener('click', e => {
        if (e.target.closest('[data-prev]')) { pintar(cur - 1); centrar(cur); return; }
        if (e.target.closest('[data-next]')) { pintar(cur + 1); centrar(cur); return; }
        if (e.target.closest('[data-namb-x]')) { cerrarHoja(); return; }
        const b = e.target.closest('[data-add]');
        if (!b || b.disabled || b.classList.contains('is-loading')) return;
        const p = P[cur], v = variante(p), id = p.s ? p.v : (v && v.id);
        if (!id) return;
        b.classList.add('is-loading');
        (NT.addToCart ? NT.addToCart(id, 1) : Promise.reject(new Error('')))
          .then(() => {
            b.classList.remove('is-loading');
            cerrarHoja(true);
            document.dispatchEvent(new CustomEvent('nt:added', { detail: { id: id } }));
            if (NT.openCart) NT.openCart(); else window.location.href = '/cart';
          })
          .catch(err => { b.classList.remove('is-loading'); if (NT.toast) NT.toast(errorTexto(err)); });
      });
      document.addEventListener('keydown', e => { if (e.key === 'Escape') cerrarHoja(); });
      // deslizar hacia abajo para cerrar la hoja
      let ty = null;
      card.addEventListener('touchstart', e => { ty = card.scrollTop <= 0 ? e.touches[0].clientY : null; }, { passive: true });
      card.addEventListener('touchmove', e => {
        if (ty == null) return;
        const dy = e.touches[0].clientY - ty;
        if (dy > 0) card.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: true });
      card.addEventListener('touchend', e => {
        if (ty == null) return;
        const dy = (e.changedTouches[0] ? e.changedTouches[0].clientY : ty) - ty;
        card.style.transform = '';
        ty = null;
        if (dy > 90) cerrarHoja();
      });
      const alCambiar = () => { if (!mq.matches) cerrarHoja(true); };
      if (mq.addEventListener) mq.addEventListener('change', alCambiar); else if (mq.addListener) mq.addListener(alCambiar);
      // en celular la foto empieza centrada
      if (scroller) requestAnimationFrame(() => { if (mq.matches) scroller.scrollLeft = (scroller.scrollWidth - scroller.clientWidth) / 2; });
      pintar(0, false);
    });
  }

  /* ---------- manifiesto: el nivel se centra a medida que se lee ---------- */
  function manifiesto(root) {
    $$('[data-nman]', root).forEach(sec => {
      if (!unaVez(sec)) return;
      alScroll(() => {
        const b = sec.getBoundingClientRect(), vh = window.innerHeight;
        const p = Math.min(1, Math.max(0, (vh * .85 - b.top) / (b.height * .9 + vh * .2)));
        sec.style.setProperty('--p', p.toFixed(3));
        sec.classList.toggle('is-level', p > .97);
      });
    });
  }

  /* ---------- una cosa a la vez: la foto fija cambia con cada paso ---------- */
  function unaCosa(root) {
    $$('[data-nuna]', root).forEach(sec => {
      if (!unaVez(sec)) return;
      const steps = $$('[data-nuna-step]', sec), imgs = $$('[data-nuna-img]', sec), ticks = $$('[data-nuna-tick]', sec);
      const num = $('[data-nuna-n]', sec), word = $('[data-nuna-word]', sec);
      let cur = 0;
      const ir = i => {
        if (i === cur || i < 0) return;
        cur = i;
        steps.forEach((s, k) => s.classList.toggle('is-on', k === i));
        imgs.forEach((s, k) => s.classList.toggle('is-on', k === i));
        ticks.forEach((s, k) => s.classList.toggle('is-on', k === i));
        if (num) num.textContent = String(i + 1).padStart(2, '0');
        if (word && steps[i]) { word.textContent = steps[i].dataset.word || ''; word.classList.remove('is-new'); void word.offsetWidth; word.classList.add('is-new'); }
      };
      if (!('IntersectionObserver' in window)) return;
      // en celular la foto ocupa la parte de arriba: el paso activo es el que se lee debajo de ella
      const banda = window.matchMedia('(max-width: 900px)').matches ? '-64% 0px -32% 0px' : '-48% 0px -48% 0px';
      const ob = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) ir(steps.indexOf(en.target)); }), { rootMargin: banda, threshold: 0 });
      steps.forEach(s => ob.observe(s));
    });
  }

  /* ---------- vitrina con pestañas ---------- */
  function vitrina(root) {
    $$('[data-nvit]', root).forEach(sec => {
      if (!unaVez(sec)) return;
      const tabs = $$('[data-nvit-tab]', sec), panels = $$('[data-nvit-panel]', sec), mas = $('[data-nvit-more]', sec);
      const barra = tabs.length ? tabs[0].parentElement : null;
      const ir = (i, foco) => {
        tabs.forEach((t, k) => { const on = k === i; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
        panels.forEach((p, k) => { p.hidden = k !== i; });
        if (mas && tabs[i]) mas.href = tabs[i].dataset.url;
        if (foco) tabs[i].focus({ preventScroll: true });
        if (barra && tabs[i]) barra.scrollTo({ left: tabs[i].offsetLeft - barra.clientWidth / 2 + tabs[i].clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
      };
      tabs.forEach((t, k) => {
        t.addEventListener('click', () => ir(k));
        t.addEventListener('keydown', e => {
          let j = null;
          if (e.key === 'ArrowRight') j = (k + 1) % tabs.length;
          else if (e.key === 'ArrowLeft') j = (k - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') j = 0;
          else if (e.key === 'End') j = tabs.length - 1;
          if (j !== null) { e.preventDefault(); ir(j, true); }
        });
      });
    });
  }

  /* ---------- planeador de orden ---------- */
  function planeador(root) {
    $$('[data-nplan]', root).forEach(sec => {
      if (!unaVez(sec)) return;
      const cfg = leer($('[data-nplan-cfg]', sec)) || {};
      const T = leer($('[data-nplan-tareas]', sec)) || {};
      const P = leer($('[data-nplan-prods]', sec)) || [];
      const KEY = 'nhb-planeador-v1';
      const chips = $$('[data-esp]', sec), mins = $$('[data-nplan-min]', sec);
      const diasEl = $('[data-nplan-days]', sec), panelesEl = $('[data-nplan-panels]', sec);
      const sumEl = $('[data-nplan-sum]', sec), barEl = $('[data-nplan-bar]', sec), waEl = $('[data-nplan-wa]', sec), subEl = $('[data-nplan-print-sub]', sec);
      if (!diasEl || !panelesEl) return;
      const id = uid('np');
      const ORDEN = chips.map(c => c.dataset.esp);
      const NOM = cfg.nombres || {};
      const DIAS = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
      const CORTO = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];
      const hoy = new Date(), dHoy = (hoy.getDay() + 6) % 7;
      const lunes = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() - dHoy);
      const fecha = d => new Date(lunes.getFullYear(), lunes.getMonth(), lunes.getDate() + d).getDate();
      const semana = lunes.getFullYear() + '-' + (lunes.getMonth() + 1) + '-' + lunes.getDate();

      const g = guardado.get(KEY, null) || {};
      const st = {
        s: Array.isArray(g.s) ? g.s.filter(x => ORDEN.indexOf(x) >= 0) : (Array.isArray(cfg.s) ? cfg.s.filter(x => ORDEN.indexOf(x) >= 0) : ORDEN.slice(0, 2)),
        m: [10, 20, 30].indexOf(+g.m) >= 0 ? +g.m : ([10, 20, 30].indexOf(+cfg.m) >= 0 ? +cfg.m : 20),
        d: (g.sem === semana && g.d && typeof g.d === 'object') ? g.d : {}, // las casillas vuelven a cero cada semana
        dia: dHoy
      };
      const save = () => guardado.set(KEY, { s: st.s, m: st.m, d: st.d, sem: semana });

      // "lo que te ayuda": producto real por tipo, etiqueta y palabras clave
      const PN = P.map(p => ({ p: p, n: norm(p.t) }));
      function ayuda(a, salt, evitar) {
        if (!a) return null;
        const kws = (a.kw || []).map(norm), c = [];
        PN.forEach(x => {
          const tg = a.tg && (x.p.tg || []).indexOf(a.tg) >= 0, ty = a.ty && x.p.ty === a.ty;
          if (!tg && !ty) return;
          let s = (tg ? 2 : 0) + (ty ? 1 : 0);
          if (kws.some(k => x.n.indexOf(k) >= 0)) s += 4;
          c.push({ p: x.p, s: s });
        });
        if (!c.length) return null;
        const best = Math.max.apply(null, c.map(x => x.s));
        let top = c.filter(x => x.s === best);
        top = top.filter(x => !evitar.has(x.p.id));
        if (!top.length) return null; // ya se sugirió hoy: mejor no repetir
        return top[salt % top.length].p;
      }

      function armar() {
        const sp = ORDEN.filter(x => st.s.indexOf(x) >= 0), n = sp.length, M = st.m, usado = {}, dias = [];
        for (let d = 0; d < 7; d++) {
          let libre = M;
          const L = [];
          const tomar = (s, max) => {
            const pool = T[s] || [];
            for (let k = 0; k < max && libre >= 5; k++) {
              const opc = pool.filter(t => t.m <= libre && !L.some(x => x.id === t.id));
              if (!opc.length) break;
              opc.sort((a, b) => ((usado[a.id] || 0) - (usado[b.id] || 0)) || (pool.indexOf(a) - pool.indexOf(b)));
              const t = opc[0];
              usado[t.id] = (usado[t.id] || 0) + 1;
              L.push(Object.assign({ s: s }, t));
              libre -= t.m;
            }
          };
          if (n) {
            if (d === 6 && T.domingo && T.domingo.m <= libre) { L.push(Object.assign({ s: 'casa' }, T.domingo)); libre -= T.domingo.m; }
            tomar(sp[d % n], M >= 30 ? 3 : 2);
            for (let j = 1; j < n && libre >= 5; j++) tomar(sp[(d + j) % n], 1);
          }
          L.forEach((t, k) => { t.key = d + ':' + t.id; t.k = k; });
          dias.push(L);
        }
        // productos sin repetir dentro del mismo día
        dias.forEach((L, d) => { const ev = new Set(); L.forEach((t, k) => { t.prod = ayuda(t.a, d + k, ev); if (t.prod) ev.add(t.prod.id); }); });
        return dias;
      }

      let plan = [];
      const tarea = t =>
        '<li class="ntask' + (st.d[t.key] ? ' is-done' : '') + '">' +
          '<label class="ntask__c"><input type="checkbox" data-k="' + esc(t.key) + '"' + (st.d[t.key] ? ' checked' : '') + '><span class="ntask__box">' + ICON.check + '</span>' +
          '<span class="ntask__t"><span>' + esc(t.t) + '</span><small class="ntask__meta">' + t.m + ' min · ' + esc(NOM[t.s] || '') + '</small></span></label>' +
          (t.prod ? '<a class="ntask__help" href="' + esc(t.prod.u) + '">' + (t.prod.i ? '<img src="' + esc(t.prod.i) + '" alt="" loading="lazy" width="46" height="46">' : '') +
            '<span><small>' + esc(cfg.ayuda || 'Lo que te ayuda') + '</small><b>' + esc(t.prod.t) + '</b><em>' + (t.prod.pv ? 'Desde ' : '') + money(t.prod.p) + '</em></span></a>' : '') +
        '</li>';

      function pintar() {
        plan = armar();
        const sp = ORDEN.filter(x => st.s.indexOf(x) >= 0);
        chips.forEach(c => c.setAttribute('aria-pressed', st.s.indexOf(c.dataset.esp) >= 0 ? 'true' : 'false'));
        mins.forEach(r => { r.checked = +r.value === st.m; });
        diasEl.innerHTML = plan.map((L, d) =>
          '<button type="button" role="tab" class="nplan__day" id="' + id + 't' + d + '" aria-controls="' + id + 'p' + d + '" aria-selected="' + (d === st.dia) + '" tabindex="' + (d === st.dia ? 0 : -1) + '" data-dia="' + d + '" aria-label="' + DIAS[d] + ' ' + fecha(d) + (d === dHoy ? ', hoy' : '') + '">' +
            '<span aria-hidden="true">' + CORTO[d] + '</span><b aria-hidden="true">' + fecha(d) + '</b>' + (d === dHoy ? '<em aria-hidden="true">Hoy</em>' : '') + '<span class="nplan__dp" aria-hidden="true"><i></i></span></button>').join('');
        panelesEl.innerHTML = plan.map((L, d) => {
          const total = L.reduce((a, t) => a + t.m, 0);
          return '<div class="nplan__panel" role="tabpanel" id="' + id + 'p' + d + '" aria-labelledby="' + id + 't' + d + '"' + (d === st.dia ? '' : ' hidden') + '>' +
            '<div class="nplan__ph"><h3>' + DIAS[d] + ' ' + fecha(d) + (d === dHoy ? ' <em>· hoy</em>' : '') + '</h3><span>' + (L.length ? L.length + (L.length === 1 ? ' tarea' : ' tareas') + ' · ' + total + ' min' : '') + '</span></div>' +
            (L.length ? '<ul class="nplan__list">' + L.map(tarea).join('') + '</ul>' : '<p class="nplan__empty">' + (sp.length ? 'Día libre.' : 'Escoge al menos un espacio para armar tu semana.') + '</p>') +
          '</div>';
        }).join('');
        actualizar();
      }

      const abs = u => {
        const o = (window.location.origin && /^https?:/.test(window.location.origin)) ? window.location.origin : (cfg.origen || '');
        return o + u;
      };
      function textoWA(sp) {
        const lin = [((cfg.titulo || 'Mi semana en orden') + (cfg.marca ? ' · ' + cfg.marca : '')), st.m + ' min al día · ' + sp.map(x => NOM[x]).join(', '), ''];
        plan.forEach((L, d) => {
          if (L.length) lin.push(CORTO[d] + ' ' + fecha(d) + ': ' + L.map(t => (st.d[t.key] ? '✓ ' : '') + t.t.replace(/\.$/, '') + ' (' + t.m + ' min)').join(' · '));
        });
        const vistos = [];
        plan.forEach(L => L.forEach(t => { if (t.prod && vistos.indexOf(t.prod) < 0) vistos.push(t.prod); }));
        if (vistos.length) {
          lin.push('', 'Lo que me puede ayudar:');
          vistos.slice(0, 4).forEach(p => lin.push('• ' + p.t + ': ' + abs(p.u)));
        }
        return lin.join('\n');
      }

      function actualizar() {
        let tot = 0, hechas = 0;
        const tabs = $$('[data-dia]', diasEl);
        plan.forEach((L, d) => {
          const h = L.filter(t => st.d[t.key]).length;
          tot += L.length; hechas += h;
          const tab = tabs[d];
          if (tab) {
            const i = $('.nplan__dp i', tab);
            if (i) i.style.width = (L.length ? Math.round(h / L.length * 100) : 0) + '%';
            tab.classList.toggle('is-done', L.length > 0 && h === L.length);
          }
        });
        const sp = ORDEN.filter(x => st.s.indexOf(x) >= 0);
        const nombres = sp.map(x => NOM[x]).join(', ');
        if (sumEl) {
          sumEl.innerHTML = sp.length
            ? 'Tu semana: <b>' + tot + ' tareas cortas</b> · ' + st.m + ' min al día · ' + esc(nombres) + '. ' + (hechas ? (hechas === tot ? '<b>¡Semana completa!</b>' : 'Llevas <b>' + hechas + ' de ' + tot + '</b>.') : 'Marca cada tarea cuando la termines.')
            : 'Escoge al menos un espacio para armar tu semana.';
        }
        if (barEl) barEl.style.width = tot ? (hechas / tot * 100).toFixed(1) + '%' : '0%';
        if (subEl) subEl.textContent = st.m + ' min al día · ' + nombres;
        if (waEl) { waEl.href = 'https://wa.me/?text=' + encodeURIComponent(textoWA(sp)); waEl.classList.toggle('is-off', !sp.length); }
        const bp = $('[data-nplan-print]', sec);
        if (bp) bp.classList.toggle('is-off', !sp.length);
      }

      function irDia(d, foco) {
        st.dia = d;
        $$('[data-dia]', diasEl).forEach((b, k) => { b.setAttribute('aria-selected', k === d ? 'true' : 'false'); b.tabIndex = k === d ? 0 : -1; });
        $$('.nplan__panel', panelesEl).forEach((p, k) => { p.hidden = k !== d; });
        if (foco) { const b = diasEl.children[d]; if (b) b.focus(); }
      }

      chips.forEach(c => c.addEventListener('click', () => {
        const e = c.dataset.esp;
        st.s = st.s.indexOf(e) >= 0 ? st.s.filter(x => x !== e) : st.s.concat(e);
        save(); pintar();
      }));
      mins.forEach(r => r.addEventListener('change', () => { if (r.checked) { st.m = +r.value; save(); pintar(); } }));
      diasEl.addEventListener('click', e => { const b = e.target.closest('[data-dia]'); if (b) irDia(+b.dataset.dia); });
      diasEl.addEventListener('keydown', e => {
        const b = e.target.closest('[data-dia]');
        if (!b) return;
        const d = +b.dataset.dia;
        let j = null;
        if (e.key === 'ArrowRight') j = (d + 1) % 7;
        else if (e.key === 'ArrowLeft') j = (d + 6) % 7;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = 6;
        if (j !== null) { e.preventDefault(); irDia(j, true); }
      });
      panelesEl.addEventListener('change', e => {
        const i = e.target.closest('[data-k]');
        if (!i) return;
        if (i.checked) st.d[i.dataset.k] = 1; else delete st.d[i.dataset.k];
        const li = i.closest('.ntask');
        if (li) li.classList.toggle('is-done', i.checked);
        save(); actualizar();
      });
      const bp = $('[data-nplan-print]', sec);
      if (bp) bp.addEventListener('click', () => {
        document.body.classList.add('nh-print');
        window.addEventListener('afterprint', () => document.body.classList.remove('nh-print'), { once: true });
        window.print();
      });
      const br = $('[data-nplan-reset]', sec);
      if (br) br.addEventListener('click', () => { st.d = {}; save(); pintar(); });
      pintar();
    });
  }

  /* ---------- producto: contador de fotos de la galería ---------- */
  function galeria(root) {
    $$('[data-gal-track]', root).forEach(track => {
      if (!unaVez(track)) return;
      const gal = track.closest('.gal'), cnt = gal && $('[data-gal-count]', gal);
      if (!cnt) return;
      const n = track.children.length;
      const upd = () => { const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); cnt.textContent = Math.min(n, i + 1) + ' / ' + n; };
      track.addEventListener('scroll', () => requestAnimationFrame(upd), { passive: true });
      upd();
    });
  }

  /* ---------- 404: la caja vuelve a su lugar ---------- */
  function pagina404(root) {
    $$('[data-n404]', root).forEach(s => { if (unaVez(s)) setTimeout(() => s.classList.add('is-ok'), reduce ? 0 : 1300); });
  }

  function iniciar(root) {
    [heroe, espacios, antesDespues, ambiente, manifiesto, unaCosa, vitrina, planeador, galeria, pagina404].forEach(fn => {
      try { fn(root); } catch (e) { if (window.console) console.warn('NayHogar:', fn.name, e); }
    });
  }
  iniciar(document);
  // editor de temas de Shopify: al recargar una sección, se vuelve a armar y se muestra sin esperar el scroll
  document.addEventListener('shopify:section:load', e => {
    $$('[data-reveal]', e.target).forEach(x => x.classList.add('in'));
    iniciar(e.target);
  });
})();
